var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 57,
    viewBox: "0 0 45 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 0.583374L22.66 0.602916C23.2831 0.676403 23.8633 0.957679 24.307 1.40136C24.7507 1.84505 25.032 2.42527 25.1055 3.04842L25.125 3.37504V14.5417L25.139 14.9605C25.2389 16.2898 25.8111 17.5395 26.7522 18.4836C27.6932 19.4278 28.9411 20.0041 30.27 20.1083L30.7083 20.125H41.875L42.2016 20.1446C42.8248 20.2181 43.405 20.4993 43.8487 20.943C44.2924 21.3867 44.5736 21.9669 44.6471 22.5901L44.6667 22.9167V48.0417C44.6668 50.1779 43.8506 52.2334 42.3851 53.7877C40.9196 55.3419 38.9155 56.2774 36.783 56.4027L36.2917 56.4167H8.375C6.23879 56.4168 4.18327 55.6006 2.62902 54.1351C1.07477 52.6696 0.139283 50.6656 0.0139587 48.533L1.30104e-08 48.0417V8.95837C-0.000118986 6.82216 0.816074 4.76664 2.28158 3.2124C3.74709 1.65815 5.75113 0.722657 7.88367 0.597333L8.375 0.583374H22.3333Z",
    fill: "#C27CF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.875 14.5417H30.7084L30.7056 3.37225L41.875 14.5417Z",
    fill: "#C27CF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.58e2fcc35c8cdcef336ff642ddb1e4c0.svg";
export { ForwardRef as ReactComponent };